import { format } from 'date-fns';

export const formatTime = (timestamp: string, _locale?: string): string => {
  const date = new Date(timestamp);
  return format(date, 'HH:mm');
};
